/* eslint-disable */

import {ROOT_URL, HOST, TOKEN} from './etc/constants'
import LANG from './etc/language'
import {getRandomInt, isTabletOrMobile, isMobile } from './kit'
import Nprogress from 'nprogress'
import Cookies from 'universal-cookie';
import { getHome, getMaterials, getMaterialsKinds, getProjects, getProjectsAreas, getAbout, getContact,
    setProjectsImagesLoaded, setAboutImagesLoaded, setMaterialsImagesLoaded, setHomeVideoReady } from './behaviors/data'
import { 
    mapLeaving, singleLeaving, resetAreaFilters, resetKindFilters, setCompassHiddenOnMobile, setKindFeaturedImagePath, setCursor, setCurrentTimelineProjectIndex, 
    setProjectsDate, setProjectsViewMode, setProjectsGridActive, setMaterialsGridActive, toggleKindFilter, 
    toggleAreaFilter, setAppLoaded, setCompass, toggleMenu, setLoading, setLanguage, setKindTitle, getIP } from './behaviors/app'
import { push } from 'react-router-redux'
import initLocale from './etc/localize'
import axios from 'axios'


var instance = null

import store from './etc/store'

class Superface{

	constructor(){
        
		if(!instance){
            this.handleChange = this.handleChange.bind(this)
            this.init()
			instance = this
		}
		return instance
    }
    
    init(){

        this.IS_MOBILE = isMobile()
        this.IS_MOBILE_OR_TABLET = isTabletOrMobile()

        this.loaded = false
        this.ready = false
        this.canDoIt = true
        Nprogress.speed = 100
        store.subscribe( this.handleChange )

    }
    
    /*=============================================
    =            STATES                           =
    =============================================*/
    
    datas(){ return store.getState().data }
    
    app(){ return store.getState().app }
    
    routing(){ return store.getState().routing }
    
    /*=============================================
    =            APP BEHAVIOURS                   =
    =============================================*/
    
    handleChange(){
        if( this.loaded ) return
        
        let datas = this.datas()
        let app = this.app()
        
        this.ready = (
            !datas.materials.isEmpty() &&
            !datas.materialsKinds.isEmpty() &&
            !datas.projects.isEmpty() &&
            !datas.projectsAreas.isEmpty() &&
            datas.home &&
            datas.contact &&
            datas.about
        )
        
        if( !this.ready ) return
        
        this.loaded = (
            datas.projectsImagesLoaded &&
            datas.aboutImagesLoaded &&
            datas.materialsImagesLoaded &&
            datas.homeVideoReady
        )
        
        // console.log('loaded : ' + this.loaded)
       
        if( !this.loaded && !this.isLoadingAssets ) {
            Nprogress.inc()
            this.isLoadingAssets = true
            this.loadAssets()
        }
        
        if( !this.loaded ) return
        
        if ( this.isLoadingAssets ){
            this.isLoadingAssets = false
            if( app.currentSection !== 'matieres' && app.currentSection !== 'projets' ){
                this.setLoading(false)
            }
            store.dispatch( setAppLoaded() )
        }
        
    }

    toggleMenu(){
        store.dispatch( toggleMenu() )
    }
    
    getCardinal(path){
        switch( true ){
            case path.includes('projets'):
                return 'E'
            case path.includes('matieres'):
                return 'W'
            case path.includes('notre-metier'):
                return 'S'
            case path.includes('contact'):
                return 'N'
            default :
                return 'center'
        }   
    }

    getIP(){
        store.dispatch( getIP() )
    }


    setCompass(cardinal){
        store.dispatch( setCompass(cardinal) )
    }

    setCompassHiddenOnMobile(bool){
        store.dispatch( setCompassHiddenOnMobile(bool) )
    }

    /*=============================================
    =            LOADING                          =
    =============================================*/

    setLoading(bool){ 
        // console.log(bool)
        if(bool){
            Nprogress.set(0)
            Nprogress.start()
        }else{
            setTimeout( () => { Nprogress.done() }, 100 );
        }
        store.dispatch( setLoading(bool) )
    }

    loadJSONdatas(){
        store.dispatch( getMaterials() )
        store.dispatch( getMaterialsKinds() )
        store.dispatch( getProjects() )
        store.dispatch( getProjectsAreas() )
        store.dispatch( getContact() )
        store.dispatch( getAbout() )
        store.dispatch( getHome() )
    }

    loadAssets(){
        this.loadAboutImages()
        if( !this.IS_MOBILE_OR_TABLET ){
            this.loadHomeVideo()
        }else{
            this.loadHomeImageBackup()
        }
        this.loadProjectsImages()
        this.loadMaterialsImages()
    }

    loadAboutImages(){
        let about = this.datas().about
        let imagesLoaded = 0
        let imagesToload = 0
        let images = []

        images.push( about.interstice )
        
        for( var i = 1; i <= 7; i++ ){ images.push( about['image_' + i] ) }

        images.forEach( (image, i) => {

            if(image.path){
                
                let img = new Image()
                
                img.onload = () => {
                    imagesLoaded += 1
                    if( imagesLoaded === imagesToload ){
                        Nprogress.inc()
                        store.dispatch( setAboutImagesLoaded() )         
                    }
                }
                img.src = this.assetUrl(image.path)
                
                imagesToload += 1

            }
            
        })
        
    }

    loadMaterialsImages(){
        return store.dispatch( setMaterialsImagesLoaded() )
        // return
        let materials = this.datas().materials
        
        let images_loaded = 0
        let images_to_load = 0
        
        materials.forEach( mat => {
            
            if( mat.image.path !== undefined  ){
                const str = `${ROOT_URL.replace('3000', '8888')}/superadmin/api/cockpit/image?token=${TOKEN}&src=${mat.image._id}&m=resize&w=560&q=50`;
                axios.get(str)
                .then( result => {
                    images_loaded += 1;
                    let img = new Image()
                    // img.onload = () => {
                    //     images_loaded += 1
                    // console.log( result.data )
                    mat.image.thumb_path = result.data
                    if( images_loaded === images_to_load ){
                            
                    //     }
                    }
                    
                    // img.src = this.assetUrl(result.data)
                });
                images_to_load += 1
            }
            
        });
        
    }

    loadHomeImageBackup(){
        const home = this.datas().home
        this.HOME_BACKUP_INDEX = getRandomInt(0, home.backup_mobile.length - 1 )
        let image = home.backup_mobile[this.HOME_BACKUP_INDEX]
        let img = new Image()
                
        img.onload = () => {
            store.dispatch( setHomeVideoReady() )
        }
        
        img.src = this.assetUrl(image.path)
    }

    setloadProgress(float){
        if( float === 'inc' ) return Nprogress.inc()
        Nprogress.set(float)
    }

    loadHomeVideo(){

        const home = this.datas().home
        this.HOME_VIDEO_INDEX = getRandomInt(0, home.videos.length - 1)
        let video = home.videos[this.HOME_VIDEO_INDEX]
        let vid = document.createElement("video")
        vid.src = this.assetUrl(video.value.path)
        vid.load()
        // vid.addEventListener("progress", function() {
        //     console.log(vid.readyState)
        //     if( vid.readyState >= 3 ){
        //         store.dispatch( setHomeVideoReady() )
        //     }
        //     // if( vid.buffered.length > 0 ){
        //     //     console.log( Math.round(vid.buffered.end(0)) / Math.round(vid.seekable.end(0)) )
        //     //     if (Math.round(vid.buffered.end(0)) / Math.round(vid.seekable.end(0)) === 1) {
        //     //         store.dispatch( setHomeVideoReady() )
        //     //     }
        //     // }
        // }, false);
        checkIfVideoIsReady(vid)
        
        function checkIfVideoIsReady($vid){
        
            window.setTimeout( () => {
                console.log($vid.readyState)
                if( $vid.readyState === 2 ){
                    Nprogress.inc()
                }
                if( $vid.readyState >= 3 ){
                    
                    store.dispatch( setHomeVideoReady() )
                    
                }else{
                    checkIfVideoIsReady($vid)
                }
            }, 500)
        }
    }

    loadProjectsImages(){
        
        store.dispatch( setProjectsImagesLoaded() )

    }
    
    /*=============================================
    =         ROUTING & URLS & SECTION            =
    =============================================*/
    
    getCurrentUrl(){
        return ROOT_URL + this.routing().location.pathname
    }

    goTo(path){
        if( this.app().menuOpen ) store.dispatch( toggleMenu() )
        store.dispatch( setCompass( this.getCardinal(path) ) )
        store.dispatch( push(path) )
    }
    
    assetUrl(path){
      if (!path) return
        
        if (path.includes('http')){
            let arr = path.split('/')
            arr.shift()
            arr.shift()
            arr.shift()
            path = '/' + arr.join('/')
        }
        let src = path.includes('superadmin') ? path : '/superadmin/storage/uploads' + path
        return src
    }

    uri(key){
        const URIS = {
            'matieres' : 'matieres',
            'projets' : 'projets',
            'notre-metier' : 'notre-metier',
            'contact' : 'contact',
            'accueil' : '',
        }
        return '/' + URIS[key]
    }

    getSectionName(section){
        const NAMES = {
            'matieres' : 'Matières',
            'projets' : 'Projets',
            'notre-metier' : 'Notre Métier',
            'contact' : 'Contact',
            'accueil' : 'Accueil',
        }
        return NAMES[section] ? NAMES[section] : ''
    }

    isOnSingle(){
        return this.app().isOnSingle
    }

    /*=============================================
    =            TRANSLATION & FIELDS             =
    =============================================*/
    
    field(obj, key){
        const lang = this.app().lang
        if( lang !== 'fr' ){
            if( obj[key + '_' + lang ] && obj[key + '_' + lang] !== '' ){
                return obj[key + '_' + lang]
            }
        }
        return obj[key]
    }

    translate(str){
        
        if( LANG[str] ){
            if( !LANG[str][this.app().lang] ) return str
            return LANG[str][this.app().lang]
        }else{
            return str
        }

    }

    setLang(str){
        const cookies = new Cookies()
        cookies.set('locale', str)
        store.dispatch( setLanguage(str) )
    }

    getLang(){
        return this.app().lang
    }

    setCursor(string){
        store.dispatch( setCursor(string) )
    }

    /*=============================================
    =            MATERIALS                        =
    =============================================*/
    
    enableMaterialsGrid(){
        store.dispatch( setMaterialsGridActive(true) )
    }
    
    disableMaterialsGrid(){
        store.dispatch( setMaterialsGridActive(false) )
    }
 
    getNextMaterialsKind(kind){
        const kinds = this.datas().materialsKinds
        for (let i = 0; i < kinds.length; i++) {
            if( kinds[i]._id === kind._id){
                if( kinds[i + 1] !== undefined ) return kinds[i + 1]
                return kinds[0]
            }
        }
        return null
    }
    
    getPreviousMaterialsKind(kind){
        const kinds = this.datas().materialsKinds
        for (let i = 0; i < kinds.length; i++) {
            if( kinds[i]._id === kind._id ){
                if( kinds[i - 1] !== undefined ) return kinds[i - 1]
                return kinds[kinds.length - 1]
            }
        }
        return null
    }

    setKindTitle(title){
        store.dispatch( setKindTitle(title) )
    }

    toggleKindFilter(slug){
        store.dispatch( toggleKindFilter(slug) )
    }

    setKindFeaturedImagePath(path){
        
        if( path != undefined ){
            store.dispatch( setKindFeaturedImagePath(path) )
        }
    }   

    /*=============================================
    =            PROJECTS                         =
    =============================================*/
    
    getNextProject(project){
        const projects = this.datas().projects
        for (let i = 0; i < projects.length; i++) {
            if( projects[i]._id === project._id ) {
                const nextProject = projects[i + 1]
                if( nextProject !== undefined ){
                    if( this.projectHasSingle(nextProject) ){
                        return nextProject
                    } else {
                        return this.getNextProject(nextProject)
                    }
                }else{
                    return this.getNextProject(projects[0])
                }
            }
        }
        return null
    }
    
    projectHasSingle(project){
        return project.medias.length > 0
    }

    getPreviousProject(project){
        const projects = this.datas().projects
        for (let i = 0; i < projects.length; i++) {
            if( projects[i]._id === project._id ){
                const previousProject = projects[i - 1]
                if( previousProject !== undefined ){
                    if( this.projectHasSingle(previousProject) ){
                        return previousProject
                    } else {
                        return this.getPreviousProject(previousProject)
                    }
                }else{
                    return this.getPreviousProject( projects[projects.length - 1 ] )
                }
            }
        }
        return null
    }

    setCurrentTimelineProjectIndex(index){
        store.dispatch( setCurrentTimelineProjectIndex(index) )
    }
  
    toggleAreaFilter(slug){
        store.dispatch( toggleAreaFilter(slug) )
    }

    setProjectsViewMode(mode){
        store.dispatch( setProjectsViewMode(mode) )
    }
    
    setProjectsDate(date){
        store.dispatch( setProjectsDate(date) )
    }
 
    enableProjectsGrid(){
        store.dispatch( setProjectsGridActive(true) )
    }
    
    disableProjectsGrid(){
        store.dispatch( setProjectsGridActive(false) )
    }

    /*=============================================
    =            GET ENTRY                        =
    =============================================*/
    
    getMaterialKindById(id){
        const kinds = this.datas().materialsKinds
        for (let i = 0; i < kinds.length; i++) {
            if( kinds[i]._id === id ) return kinds[i]
        }
        return null
    }
    
    getProjectAreaById(id){
        const areas = this.datas().projectsAreas
        for (let i = 0; i < areas.length; i++) {
            if( areas[i]._id === id ) return areas[i]
        }
        return null
    }
    
    getMaterialKindBySlug(slug){
        const kinds = this.datas().materialsKinds
        
        for (let i = 0; i < kinds.length; i++) {
            if( kinds[i].slug === slug ) return kinds[i]
        }
        return null
    }

    getProjectBySlug(slug){
        const projects = this.datas().projects
        
        for (let i = 0; i < projects.length; i++) {
            if( projects[i].slug === slug ) return projects[i]
        }
        return null
    }

    getSingleBySlug(slug, type){
        if( type === 'projet' ){
            return this.getProjectBySlug(slug)
        }
        if( type === 'kind' ){
            return this.getMaterialKindBySlug(slug)
        }
    }

    getNextSingle(single, type){
        if( type === 'projet' ){
            return this.getNextProject(single)
        }
        if( type === 'kind' ){
            return this.getNextMaterialsKind(single)
        }
    }
    
    getPreviousSingle(single, type){
        if( type === 'projet' ){
            return this.getPreviousProject(single)
        }
        if( type === 'kind' ){
            return this.getPreviousMaterialsKind(single)
        }
    }

    toggleFilter(slug, type){
        if( type === 'projet' ){
            return this.toggleAreaFilter(slug)
        }
        if( type === 'kind' ){
            return this.toggleKindFilter(slug)
        }
    }

    resetFilters(type){
        if( type === 'projet' ){
            return store.dispatch( resetAreaFilters() )
        }
        if( type === 'kind' ){
            return  store.dispatch( resetKindFilters() )
        }
    }

    singleLeaving(bool){
        store.dispatch( singleLeaving(bool) )
    }
    mapLeaving(bool){
        store.dispatch( mapLeaving(bool) )
    }

}

export default new Superface()



// WEBPACK FOOTER //
// ./src/Superface.js